document.addEventListener("DOMContentLoaded", function () {
  const blogNavs = document.querySelectorAll(".corner-blog-nav"); // Select all instances of the class
  if (!blogNavs.length) return;

  blogNavs.forEach(blogNav => {
      const parentNav = blogNav.closest("a.navlink"); // Ensure it finds the correct parent <a>
      const megaMenu = document.querySelector(".dropdown_container");

      if (!parentNav || !megaMenu) return;

      parentNav.addEventListener("mouseenter", () => {
          megaMenu.classList.add('active');
          parentNav.classList.add('active');
      });
      megaMenu.addEventListener("mouseenter", () => {
          megaMenu.classList.add('active');
          parentNav.classList.add('active');
      });

      parentNav.addEventListener("mouseleave", () => {
          megaMenu.classList.remove('active');
          parentNav.classList.remove('active');
      });
      megaMenu.addEventListener("mouseleave", () => {
          megaMenu.classList.remove('active');
          parentNav.classList.remove('active');
      });
  });
});
